export let PaymentStatus = /*#__PURE__*/function (PaymentStatus) {
  PaymentStatus["INITIALIZED"] = "INITIALIZED";
  PaymentStatus["PENDING"] = "PENDING";
  PaymentStatus["ACTIVE"] = "ACTIVE";
  PaymentStatus["DECLINED"] = "DECLINED";
  PaymentStatus["EXPIRED"] = "EXPIRED";
  PaymentStatus["CANCELED"] = "CANCELED";
  PaymentStatus["REFUNDED"] = "REFUNDED";
  PaymentStatus["SUSPENDED"] = "SUSPENDED";
  PaymentStatus["FAILED"] = "FAILED";
  return PaymentStatus;
}({});
//# sourceMappingURL=payment-status.js.map